export const clearCartRequiredField = () => {
    sessionStorage.removeItem('accountingType')
    sessionStorage.removeItem('accountDeliveryAddress')
    sessionStorage.removeItem('requestDeliveryBy')
}